import React, { Component } from 'react';
import { connect } from 'react-redux';
import { injectIntl, intlShape } from 'react-intl';
import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import { withRouter } from '../../../util/withRouter';
import { Button } from 'react-bootstrap';
import { handleError, resetPassword } from '../AuthActions';
import Testimonial from '../components/Testimonial/Testimonial';

import logo from './img/logo-nave-icon.svg';

// Import Style
import '../Auth.scss';

class ResetPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      password: '',
      token: '',
    };
  }

  componentDidMount() {
    this.setState({
      token: this.props.routeParams.token,
    });
  }

  handleChange = (ev) => {
    this.setState({
      [ev.target.name]: ev.target.value,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    if (!this.state.password) {
      this.props.setError({
        data: {
          password: {
            msg: 'error.password.empty',
          },
        },
      });
      return false;
    }

    this.props
      .reset({
        password: this.state.password,
        token: this.state.token,
      })
      .then(
        () => {
          this.props.router.replace('/login');
        },
        (err) => {}
      );
  };

  render() {
    return (
      <div className='login_bg'>
        <Helmet>
          <title>{pageTitle('Reset password')}</title>
          <link rel="alternate" href={`https://${this.props.app}.getnave.com`} hrefLang="en-us" />
        </Helmet>
        <div className={`login_form ${this.props.app}`}>
          <div className='logo'>
            <img src={logo} alt="" />
          </div>
          <div className='login_content'>
            <div className='left_part'>
              <h1>Reset password</h1>
              <form className='form' noValidate onSubmit={this.handleSubmit}>
                <div className='form_container'>
                  <label>New Password</label>
                  <input
                    autoFocus
                    className='form-control'
                    type={this.state.show ? 'text' : 'password'}
                    name="password"
                    id="password"
                    f
                    value={this.state.password}
                    onChange={this.handleChange}
                  />
                </div>
                <Button variant="primary" type="submit">
                  Reset
                </Button>
              </form>
            </div>
            <div className='right_part'>
              <h3>Nave is trusted by 7,000+ agile teams</h3>
              <Testimonial />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

ResetPage.propTypes = {
  intl: intlShape.isRequired,
};

const mapDispatchToProps = (dispatch) => {
  return {
    reset: (body) => dispatch(resetPassword(body)),
    setError: (err) => dispatch(handleError(err)),
  };
};

function mapStateToProps(state) {
  return {
    app: state.app.app,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(ResetPage)));
